module.exports = __webpack_public_path__ + "img/consult_list2.37aced66.png";